module.exports = __webpack_public_path__ + "static/img/background.4f65cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty/background.png
// module id = Wv2s
// module chunks = 152